<template>
  <div>
    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" label-width="80px" class="login-form-style"
      @submit.prevent="handleLogin">
      <el-form-item label="用户名:" prop="userName">
        <el-input v-model="loginForm.userName" type="text" auto-complete="off" placeholder="账号"
          @keydown.enter.prevent="handleLogin" @input="handleInput('userName', $event)">
          <svg-icon slot="prefix" icon-class="user" class="el-input__icon input-icon" />
        </el-input>
      </el-form-item>
      <el-form-item label="密  码:" prop="secretKey">
        <el-input v-model="loginForm.secretKey" type="password" auto-complete="off" placeholder="密码"
          @keydown.enter.prevent="handleLogin" @input="handleInput('secretKey', $event)">
          <svg-icon slot="prefix" icon-class="password" class="el-input__icon input-icon" />
        </el-input>
      </el-form-item>
      <el-form-item label="验证码:" prop="yzmCode">
        <div class="login-code-box">
          <el-input v-model="loginForm.yzmCode" auto-complete="off" placeholder="验证码" style="width: 100%"
            @keydown.enter.prevent="handleLogin" @input="handleInput('yzmCode', $event)">
            <svg-icon slot="prefix" icon-class="validCode" class="el-input__icon input-icon" />
          </el-input>
          <div class="login-code">
            <img :src="codeUrl" @click="getCode" class="login-code-img" />
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div class="footer-button">
      <el-button :loading="loading" type="primary" style="
          width: 100%;
          height: 35px;
          background-color: #4a8ddf;
          border: 1px solid #4a8ddf;
        " @click.native.prevent="handleLogin">
        <span v-if="!loading">登 录</span>
        <span v-else>登 录 中...</span>
      </el-button>
    </div>
  </div>
</template>

<script>
import { getVerifyCode } from "@/api/login";
import { getInfo } from "@/api/login";
import useUserStore from "@/store/modules/user";
import { encrypt_ecb } from "@/utils/sm4Util";
export default {
  name: "UserPwd",
  data() {
    return {
      codeUrl: "",
      loginForm: {
        userName: "",
        secretKey: "",
        yzmCode: "",
        checkCode: "",
      },
      loginRules: {
        userName: [
          {
            required: true,
            trigger: "blur",
            message: "账号格式为字母、数字、下划线",
          },
        ],
        secretKey: [
          { required: true, trigger: "blur", message: "请输入正确的密码格式" },
          // { validator: validPassword, trigger: 'blur' }
        ],
        yzmCode: [
          { required: true, trigger: "change", message: "请输入验证码" },
          { pattern: /^[A-Za-z0-9]+$/, trigger: "change", message: "验证码只能输入字母或数字" },
        ],
      },
      loading: false,
      // 验证码开关
      captchaOnOff: true,
      // 注册开关
      register: true,
      redirect: undefined,
      provinceInfo: {},
    };
  },
  created() {
    this.getCode();
    this.provinceInfo = JSON.parse(sessionStorage.getItem("provinceInfo"));
  },
  methods: {
    getCode() {
      getVerifyCode().then((res) => {
        if (res?.success) {
          this.codeUrl = "data:image/jpg;base64," + res.data.yzmCode;
          this.loginForm.checkCode = res.data.checkCode;
        } else {
          this.$message.error("验证码获取失败");
        }
      });
    },

    handleInput(field, value) {
      // 禁止输入空格
      const filteredValue = value.replace(/\s/g, '');
      this.loginForm[field] = filteredValue;
    },

    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          console.log('校验成功-------');
          const userStore = useUserStore();
          this.loading = true;
          this.getCode();

          // 过滤掉空格
          const userName = this.loginForm.userName.replace(/\s/g, '');
          const secretKey = this.loginForm.secretKey.replace(/\s/g, '');
          const yzmCode = this.loginForm.yzmCode.replace(/\s/g, '');

          // SM4加密
          const encryptedLoginType = encrypt_ecb("account");
          const encryptedAccessKey = encrypt_ecb(userName);
          const encryptedSecretKey = encrypt_ecb(secretKey);
          userStore
            .login({
              ...this.loginForm,
              userName: userName,
              verificationCodeInfo: {
                yzmCode: yzmCode,
                checkCode: this.loginForm.checkCode,
              },
              accessKey: encryptedAccessKey,
              loginType: encryptedLoginType,
              secretKey: encryptedSecretKey,
              provinceId: this.provinceInfo.areaId,
            })
            .then((rs) => {
              console.log('rs----', rs);
              if (rs.success) {
                getInfo().then((res) => {
                  console.log("res", res);
                  if (res.success) {
                    userStore.setUserInfo(res.data);
                  } else {
                    this.$message.error(res.message);
                  }
                });
                this.$message.success("登录成功");
              } else {
                this.$message.error(rs.message);
              }
              setTimeout(() => {
                this.loading = false;
              }, 300);
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error(err);
              this.getCode();
            });
        }
        setTimeout(() => {
          this.loading = false;
        }, 300);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.login-code-box {
  position: relative;
  width: 100%;

  .login-code {
    position: absolute;
    right: -15px;
    top: 1px;
    width: 100px;
    height: 36px;

    .login-code-img {
      cursor: pointer;
      height: 100%;
      vertical-align: middle;
    }
  }
}

.login-form-style {
  position: relative;
  width: 100%;

  :deep .el-form-item__label {
    line-height: 38px !important;
  }

  .el-input {
    height: 38px;

    input {
      height: 38px;
    }
  }

  .input-icon {
    height: 39px;
    width: 14px;
    margin-left: 2px;
  }
}

.footer-button {
  text-align: center;
}
</style>
